import { useMemo, useState } from 'react';
import ValidationAlert from '../components/ValidationAlert';
import FormulaModal from '../components/FormulaModal';
import ShareButton from '../components/ShareButton';
import StickyResultBar from '../components/StickyResultBar';
// import AdSlotPlaceholder from '../components/AdSlotPlaceholder';
import SEO from '../components/SEO';
import { convertScale } from '../utils/converter';
import { ROUTE_META } from '../data/routeMeta';

const SCALES = [
  { label: '10.0 Scale', value: 10 },
  { label: '5.0 Scale', value: 5 },
  { label: '4.0 Scale', value: 4 },
  { label: 'Percentage (100)', value: 100 }
];

export default function GradeConverterPage() {
  const [inputValue, setInputValue] = useState('8.5');
  const [fromScale, setFromScale] = useState('10');
  const [toScale, setToScale] = useState('4');
  const meta = ROUTE_META['/grade-converter'];

  const computed = useMemo(() => {
    if (fromScale === toScale) {
      return { error: 'Source and target scales are the same. Choose a different target scale.' };
    }
    return convertScale(inputValue, fromScale, toScale);
  }, [inputValue, fromScale, toScale]);

  const error = computed.error || '';
  const result = computed.error ? null : computed;

  return (
    <>
      <SEO title={meta.title} description={meta.description} keywords={meta.keywords} canonicalPath="/grade-converter" />
      <section className="space-y-4 pb-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold">VIT Grade Scale Converter</h1>
          <FormulaModal
            title="Scale Converter Formula"
            formula="Converted = (Current Value / From Scale) x To Scale"
          />
        </div>

        <div className="grid grid-cols-12 gap-2 border-b border-brand-border pb-2 text-center text-xs font-semibold uppercase tracking-wide text-brand-muted">
          <p className="col-span-4">Current Value</p>
          <p className="col-span-4">From Scale</p>
          <p className="col-span-4">To Scale</p>
        </div>

        <div className="grid grid-cols-12 items-center gap-2 border-b border-brand-border py-2">
          <label className="col-span-4 text-sm">
            <input
              type="number"
              step="0.01"
              min="0"
              value={inputValue}
              onChange={(event) => setInputValue(event.target.value)}
              className="elevated w-full rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-center text-brand-text"
            />
          </label>
          <label className="col-span-4 text-sm">
            <select
              value={fromScale}
              onChange={(event) => setFromScale(event.target.value)}
              className="elevated w-full rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-center text-brand-text"
            >
              {SCALES.map((scale) => <option key={scale.value} value={scale.value}>{scale.label}</option>)}
            </select>
          </label>
          <label className="col-span-4 text-sm">
            <select
              value={toScale}
              onChange={(event) => setToScale(event.target.value)}
              className="elevated w-full rounded-xl border border-brand-border bg-brand-surface px-3 py-2 text-center text-brand-text"
            >
              {SCALES.map((scale) => <option key={scale.value} value={scale.value}>{scale.label}</option>)}
            </select>
          </label>
        </div>

        {/* <AdSlotPlaceholder label="Advertisement" className="xl:hidden rounded-2xl" /> */}
        <ValidationAlert message={error} />
      </section>

      <StickyResultBar
        label="Converted Result"
        value={result ? result.value.toFixed(2) : ''}
        helper={result ? `${fromScale} scale to ${toScale} scale` : ''}
        action={result ? <ShareButton textToCopy={`GradeVIT Conversion Result: ${Number(inputValue).toFixed(2)} on ${fromScale} scale = ${result.value.toFixed(2)} on ${toScale} scale.`} /> : null}
      />
    </>
  );
}
